export default "__VITE_ASSET__mf1Ch9vW__"